import PopupConfirmCustomer from './PopupConfirmCustomer';

export default PopupConfirmCustomer;
